import { Outlet } from "react-router-dom";

/**
 * Public route component that allows access to everyone.
 * No authentication checks or redirects.
 */
export function PublicRoute() {
  return <Outlet />;
}
